/**
 * Pure decision logic for the DOM pagination enhancer (TablePaginationEnhancer).
 * Kept dependency-free so it is unit-testable without the DOM.
 *
 * Given the current row count and the table's remembered {page, pageSize,
 * everPaged}, decide the effective page and whether to paginate — and, crucially,
 * whether the empty/loading frame after a LIST → DETAIL → Back should reset the
 * restored page (it must NOT, or the restore is clobbered before data loads).
 */
export const PAGE_MIN_ROWS = 10; // mirrors DEFAULT_PAGE_SIZE in the enhancer

export function nextPageState({ rowCount, everPaged, page, pageSize }, minRows = PAGE_MIN_ROWS) {
  if (rowCount <= minRows) {
    // Small result set. If we've paged before, a filter genuinely narrowed it →
    // reset to page 1 (existing behaviour) and remember that. Otherwise the rows
    // most likely haven't loaded yet (Back/refresh) → keep the desired page so it
    // applies once they arrive; do not persist (don't overwrite the stored page).
    return everPaged
      ? { mode: 'showAll', page: 1, everPaged: true, persist: true }
      : { mode: 'showAll', page, everPaged: false, persist: false };
  }
  const totalPages = Math.max(1, Math.ceil(rowCount / pageSize));
  const clamped = Math.min(Math.max(1, page), totalPages);
  return { mode: 'paginate', page: clamped, totalPages, everPaged: true, persist: true };
}
